import script from "./order_details.vue?vue&type=script&setup=true&lang=js"
export * from "./order_details.vue?vue&type=script&setup=true&lang=js"

import "./order_details.vue?vue&type=style&index=0&id=9feb5fda&scoped=true&lang=scss"

import exportComponent from "/var/www/html/obelle-form-order/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9feb5fda"]])

export default __exports__